// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f7a65731","239":"dd6f4548","453":"b39e5af1","667":"6c329dc5"}[chunkId] + ".chunk.js";
};